/*
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-11-14 14:18:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-07 17:59:14
 * @FilePath: \wanguo_web\common_web\src\router\views\index.js
 */
import Layout from '@/page/index/'

export default [
  {
  path: '/wel',
  component: Layout,
  redirect: '/wel/index',
  children: [{
    path: 'index',
    name: '首页',
    meta: {
      i18n: 'dashboard'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/wel/index')
  }]
},

  {
    path: '/mapDemo/index',
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/mapDemo/index')
  },
//   , {
//   path: '/dict-horizontal',
//   component: Layout,
//   redirect: '/dict-horizontal/index',
//   children: [{
//     path: 'index',
//     name: '字典管理',
//     meta: {
//       i18n: 'dict'
//     },
//     component: () =>
//       import( /* webpackChunkName: "views" */ '@/views/util/demo/dict-horizontal')
//   }]
// }, {
//   path: '/dict-vertical',
//   component: Layout,
//   redirect: '/dict-vertical/index',
//   children: [{
//     path: 'index',
//     name: '字典管理',
//     meta: {
//       i18n: 'dict'
//     },
//     component: () =>
//       import( /* webpackChunkName: "views" */ '@/views/util/demo/dict-vertical')
//   }]
// },
  {
    path: '/info',
    component: Layout,
    redirect: '/info/index',
    children: [{
      path: 'index',
      name: '个人信息',
      meta: {
        i18n: 'info'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/system/userinfo')
    }]
  },
  {
    path: '/goods',
    component: Layout,
    // redirect: '/info/index',
    children: [
      {
        path:'parts',
        name:'零部件',
        meta: {
          i18n: 'material',
          type: 'material',
          typeId: 2
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-list')
      },
      {
        path:'mall',
        name:'商城',
        meta: {
          i18n: 'material',
          type: 'material',
          typeId: 3
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-list')
      },
    {
      path: "okeyMatikIntro",
      name: 'OKEY MATIK 机器介绍',
      meta: {
        i18n: 'product',
        type: 'product'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-list')
    },
    {
      path: 'part',
      name: '配套件',
      meta: {
        i18n: 'part',
        type: 'part'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-list')
    },
    {
      path: 'material',
      name: '易耗品',
      meta: {
        i18n: 'material',
        type: 'material',
        typeId: 1
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-list')
    },
    {
      path: 'product-new',
      name: '产品新增',
      meta: {
        i18n: 'product',
        type: 'product'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-edit')
    },
    {
      path: 'part-new',
      name: '配件新增',
      meta: {
        i18n: 'part',
        type: 'part'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-edit')
    },
    {
      path: 'material-new',
      name: '辅料新增',
      meta: {
        i18n: 'material',
        type: 'material'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-edit')
    },
    {
      path: 'product-edit',
      name: '产品编辑',
      meta: {
        i18n: 'product',
        type: 'product'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-edit')
    },
    {
      path: 'part-edit',
      name: '配件编辑',
      meta: {
        i18n: 'part',
        type: 'part'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-edit')
    },
    {
      path: 'material-edit',
      name: '辅料编辑',
      meta: {
        i18n: 'material',
        type: 'material'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-edit')
    },
    {
      path: 'product-detail',
      name: '产品详情',
      meta: {
        i18n: 'product',
        type: 'product'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-detail')
    },
    {
      path: 'part-detail',
      name: '配件详情',
      meta: {
        i18n: 'part',
        type: 'part'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-detail')
    },
    {
      path: 'material-detail',
      name: '辅料详情',
      meta: {
        i18n: 'material',
        type: 'material'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/goodsManagement/goods-detail')
    }
   ]
  },

  {
    path: '/service',
    component: Layout,
    // redirect: '/info/index',
    children: [

    {
      path: 'hirePurchase-new',
      name: '装机手续',
      meta: {
        i18n: 'product',

      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/service/hirePurchaseNew')
    },

   ]
  },
  {
    path: '/test',
    component: Layout,
    name: 'test',
    redirect: '/test/index',
    children: [{
      path: 'index',
      name: '测试页',
      meta: {
        i18n: 'test'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/test')
    }]
  },
  {
    path: '/test1',
    component: Layout,
    name: 'test1',
    redirect: '/test1/index',
    children: [{
      path: 'index',
      name: '测试页1',
      meta: {
        i18n: 'test1'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/test1')
    }]
  },
  {
    path: '/service',
    component: Layout,
    // redirect: '/info/index',
    children: [
      {
        path: 'alarmCommonExplain',
        name: '常见故障',
        meta: {
          i18n: 'alarmCommonExplain',
          type: 'common'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/fault/fault-list')
      },
      {
        path: 'alarmTempExplain',
        name: '临时故障',
        meta: {
          i18n: 'alarmTempExplain',
          type: 'temp'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/fault/fault-list')
      },
      {
        path: 'alarmCommonExplain-new',
        name: '新增常见故障',
        meta: {
          i18n: 'alarmCommonExplain',
          type: 'common'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/fault/fault-edit')
      },
      {
        path: 'alarmTempExplain-new',
        name: '新增临时故障',
        meta: {
          i18n: 'alarmTempExplain',
          type: 'temp'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/fault/fault-edit')
      },
      {
        path: 'alarmCommonExplain-edit',
        name: '编辑常见故障',
        meta: {
          i18n: 'alarmCommonExplain',
          type: 'common'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/fault/fault-edit')
      },
      {
        path: 'alarmTempExplain-edit',
        name: '编辑临时故障',
        meta: {
          i18n: 'alarmTempExplain',
          type: 'temp'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/fault/fault-edit')
      },
      {
        path: 'alarmCommonExplain-detail',
        name: '常见故障详情',
        meta: {
          i18n: 'alarmCommonExplain',
          type: 'common'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/fault/fault-detail')
      },
      {
        path: 'alarmTempExplain-detail',
        name: '临时故障详情',
        meta: {
          i18n: 'alarmTempExplain',
          type: 'temp'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/fault/fault-detail')
      },
      {
        path: 'complaintOrder',
        name: '投诉工单',
        meta: {
          i18n: 'complaintOrder',
          type: 'all'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/complaintOrder/complain-list')
      },
      {
        path: 'complaintDetail',
        name: '投诉详情',
        meta: {
          i18n: 'complaintDetail',
          type: 'all'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/complaintOrder/complain-detail')
      },
      {
        path: 'mineComplaintOrder',
        name: '我的投诉',
        meta: {
          i18n: 'mineComplaintOrder',
          type: 'mine'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/complaintOrder/complain-list')
      },
      {
        path: 'complaintDetail',
        name: '投诉详情',
        meta: {
          i18n: 'complaintDetail',
          type: 'mine'
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/complaintOrder/complain-detail')
      },
      {
        path: 'customerServiceCenter',
        name: '客服信息维护',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/service/customerServiceCenter')
      }
    ]
  },
  {
    path: '/archiveManager',
    component: Layout,
    // redirect: '/info/index',
    children: [
      {
        path: 'handle/:id',
        name: '档案详情',

        meta: {
          i18n: 'work',
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/archiveManager/arch')
      },
      {
        path: 'warehouse/:id',
        name: '仓库',

        meta: {
          i18n: 'work',
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/archiveManager/warehouse')
      },
      {
        path: 'report/:id',
        name: '档案详情111',

        meta: {
          i18n: 'work',
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/archiveManager/report')
      },
      {
        path: 'arch/:id',
        name: '报表',

        meta: {
          i18n: 'work',
        },
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/archiveManager/machiveList')
      },
      {
      path: 'mineBuy',
      name: '我的付款',
      meta: {
        i18n: 'mineBuy',
        type: 'myPayment'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/reportForm/index')
    },
    {
      path: 'generalOrder',
      name: '总代采购',
      meta: {
        i18n: 'generalOrder',
        type: 'generalOrder'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/reportForm/index')
    },
    {
      path: 'shopOrder',
      name: '店铺采购',
      meta: {
        i18n: 'shopOrder',
        type: 'shopOrder'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/reportForm/index')
    },
    {
      path: 'applyDevice',
      name: '装机总报表',
      meta: {
        i18n: 'applyDevice',
        type: 'applyDevice'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/reportForm/index')
    },
    {
      path: 'leaseDeposit',
      name: '租赁保证金',
      meta: {
        i18n: 'leaseDeposit',
        type: 'leaseDeposit'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/reportForm/index')
    },
    {
      path: 'generalSaleMachinehourMoney',
      name: '总收购机时款',
      meta: {
        i18n: 'generalSaleMachinehourMoney',
        type: 'generalSaleMachinehourMoney'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/reportForm/index')
    },
    // {
    //   path: 'generalSaleMachinehour',
    //   name: '机时报表',
    //   meta: {
    //     i18n: 'generalSaleMachinehour',
    //     type: 'generalSaleMachinehour'
    //   },
    //   component: () =>
    //     import( /* webpackChunkName: "views" */ '@/views/reportForm/index')
    // }
  ]
  },
  {
    path: '/goods',
    component: Layout,
    children: [
      {
        path: 'policyAnnouncement',
        name: '政策公告',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/setManager/policyAnnouncement/index')
      },
      {
        path: 'policyAnnouncement-detail',
        name: '政策公告详情',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/setManager/policyAnnouncement/detail')
      }
    ]
  },
  {
    path: '/service',
    component: Layout,
    children: [{
      path: 'dailyMaintenance',
      name: '日常维护',
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/setManager/warranty')
    }]
  },
  {
    path: '/setManager',
    component: Layout,
    children: [{
      path: 'systemSet',
      name: '系统设置',
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/setManager/systemSet')
    }]
  }
]
